import React, { useCallback, useState } from "react";
import { Card, Col, Modal, Row, Switch } from "antd";
import PreChatCustomizer from "./components/PreChatCustomizer";
import "./index.css";

const PreChatForm = ({ widget, handleWidgetChange }) => {
  const [showModal, setModal] = useState(false);

  const handleCancelCallback = useCallback(() => {
    setModal(false);
  }, []);

  const submitFormCallback = useCallback(
    (data) => {
      handleWidgetChange({ pre_chat_form_fields: data, id: widget.id });
      setModal(false);
    },
    [widget]
  );

  const handlePreChatFormChange = (value) => {
    handleWidgetChange({ pre_chat_form: value, id: widget.id });
  };

  return (
    <Card className="setting_wrapper">
      <Row className="prechat_wrapper">
        <Col span={12}>
          <h4>Pre Chat Form</h4>
        </Col>
        <Col span={12} className="switch_btn">
          <Switch
            id="custom-switch"
            name="pre_chat_form"
            defaultChecked={widget?.pre_chat_form}
            onChange={handlePreChatFormChange}
            checked={widget?.pre_chat_form}
          />
          <div
            style={{ textAlign: "end" }}
            className={`advance ${
              widget?.pre_chat_form === false ? "disabled" : "enabled"
            }`}
            onClick={() => {
              if (widget?.pre_chat_form) setModal(!showModal);
            }}
          >
            Customize
          </div>
        </Col>
      </Row>
      {showModal && (
        <Modal
          centered
          open={showModal}
          onCancel={() => setModal(false)}
          width={900}
          footer={null}
          style={{ backgroundColor: "#F7F7F9" }}
          className="adv_modal"
          closable={false}
        >
          <PreChatCustomizer
            widget={widget}
            handleCancel={handleCancelCallback}
            submitForm={submitFormCallback}
          />
        </Modal>
      )}
    </Card>
  );
};

export default PreChatForm;
